import { render, staticRenderFns } from "./JournalTemplate.vue?vue&type=template&id=052cab66&"
import script from "./JournalTemplate.vue?vue&type=script&lang=js&"
export * from "./JournalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports